/**
 * How far a song has been let out.
 *
 * One ordered ladder, not four switches. Each tier contains the ones before it,
 * so a song open to the collective is also open to the writer's church and
 * inner circle — you cannot be happy for four thousand strangers to hear
 * something and not the five people you trust most.
 *
 * Mirrors songs.reach in migration 23. If you add a tier, add it here and in
 * can_reach_song(), and nowhere else.
 */
export const REACH = [
  {
    id: 'private',
    label: 'Only you',
    who: 'Nobody but you and your co-writers',
    blurb: 'It stays where it is. You can open it out any time.',
  },
  {
    id: 'inner',
    label: 'Inner Circle',
    who: 'The few people you trust with a rough version',
    blurb: 'The ones who will tell you the truth about a second verse.',
  },
  {
    id: 'church',
    label: 'Your church',
    who: 'The worship team at churches that have verified you',
    blurb: 'They can hear it, and a pastor can endorse it.',
  },
  {
    id: 'network',
    label: 'Your circles',
    who: 'The writers’ circles you pick below',
    blurb: 'Other writers you have chosen to be in a room with.',
  },
  {
    id: 'collective',
    label: 'The Collective',
    who: 'Every writer and church on Beseter',
    blurb: 'It travels past your own church. This is the widest it goes.',
  },
]

export const REACH_ORDER = REACH.map((r) => r.id)

export const reachIndex = (id) => Math.max(0, REACH_ORDER.indexOf(id))
export const reachInfo = (id) => REACH[reachIndex(id)]

/** Everything this reach opens, widest first — the "open to" summary line. */
export const reachOpensTo = (id) =>
  REACH.slice(1, reachIndex(id) + 1).map((r) => r.label).reverse()

/** Short label for a list row or a badge. */
export const reachBadge = (id) => (id === 'private' ? 'Only you' : reachInfo(id).label)
